import React from 'react';
import arePropsEqual from 'react-fast-compare';
import MainNavigation from './MainNavigation';
import CategoriesNavigation from './CategoriesNavigation';
import ProvidersNavigation from './ProvidersNavigation';
import { useSidebarNavigation } from './hooks';
import ThemesNavigation from './ThemesNavigation';

const UnifiedNavigation: React.FC = ({ className }: { className?: string }) => {
  const { main, isLoading, categories, providers, themes } =
    useSidebarNavigation();

  const categoriesIndex = Number(Boolean(categories?.length));

  const themesIndex = categoriesIndex + Number(Boolean(themes?.length));
  const providersIndex = themesIndex + Number(Boolean(providers?.length));

  return (
    <nav role="navigation" className={className}>
      <MainNavigation isLoading={isLoading} items={main} sectionIndex={0} />
      <CategoriesNavigation
        isLoading={isLoading}
        items={categories}
        sectionIndex={categoriesIndex}
      />
      <ThemesNavigation
        isLoading={isLoading}
        items={themes}
        sectionIndex={themesIndex}
      />
      <ProvidersNavigation
        isLoading={isLoading}
        items={providers}
        sectionIndex={providersIndex}
      />
    </nav>
  );
};

export default React.memo(UnifiedNavigation, arePropsEqual);
